import { Component } from '@angular/core';

@Component({
  selector: 'app-golden-permissions',
  templateUrl: './golden-permissions.component.html',
  styleUrl: './golden-permissions.component.scss',
})
export class GoldenPermissionsComponent {
  items = [
    {
      title: 'وصف ',
      content: `   ​​موافقة واحدة على إقامة المشروع وتشغيله وإدارته بما في ذلك تراخيص البناء، وتخصيص العقارات اللازمة له، يجوز منحها للشركات بقرار من مجلس الوزراء. `,
      expanded: false,
    },
    {
      title: ' المتطلبات الأساسية ',
      content: ` ​أن تكون الشركة تم تأسيسها. `,
      expanded: false,
    },
    {
      title: ' المستندات المطلوبة ',
      content: ` 
تتقدم الشركة من خلال الموقع الإلكتروني او عن طريق الأمانة الفنية لوحدة الرخصة الذهبية الكائن مقرها في مبني الهيئة العامة الاستثمار بصالح سالم بطلب استخراج الرخصة الذهبية على النموذج المخصص لذلك مرفقا به نسختين رسميتين من المستندات التالية:

عقد تأسيس الشركة ونظامها الاساسي وشهادة تأسيسها (في حالة تم الانتهاء من تأسيسها).
مستخرج حديث من السجل تجاري للشركة (في حالة تم الانتهاء من تأسيسها).
صورة ضوئية من البطاقة الضريبية للشركة (في حالة تم الانتهاء من تأسيسها)..
دراسـة الجدوى المبدئية للمشروع والـذي يعده أحد بيوت الخبرة الوطنية أو العالمية ذات السمعة الطيبة المرخص لها.
تقديم ما يفيد الملاءة المالية لتنفيذ المشروع.
البرنامج الزمني لتنفيذ المشروع.
إقــرارًا من الممثل القانوني للشركة (رئيس مجلس الإدارة - مدير الشركة أو وكيل المساهمين/الشركاء) بالالتزام بتوفير كافة المرافق الخاصة بالبنية التحتية للمشروع (طرق - مياه - صرف صحي - كهرباء - اتصالات - معالجة المخلفات).
إقــرارا من الممثل القانوني للشركة (رئيس مجلس الإدارة - مدير الشركة أو وكيل المساهمين/الشركاء) بالالتزام بكافة الاشتراطات والضوابط المتعلقة بنشاط الشركة وفقًا للقوانين واللوائح المنظمة له.
أي مستندات أخري ترى الوحدة أهمية تقديمها 
`,
      expanded: false,
    },
    {
      title: '  الرسوم جنيه مصرى',
      content: ` يلتزم المستثمر بسداد الرسوم المقررة
`,
      expanded: false,
    },
    {
      title: ' الإطار الزمني ',
      content: ` تتطلب الرخصة من 20 الى 30 يوم عمل من تاريخ استيفاء المستندات
`,
      expanded: false,
    },
    {
      title: ' قنوات الخدمة ',
      content: `البوابة الإلكترونية https://goldenlicense.gov.eg أوالأمانة الفنية لوحدة الرخصة الذهبية الكائن مقرها في مبني الهيئة العامة الاستثمار بصالح سالم
 `,
      expanded: false,
    },
    {
      title: ' السياسات والإجراءات ',
      content: ` عبر البوابة الإلكترونية

1.      قم بالتسجيل وإنشاء الحساب و ابدأ التقديم من علي البوابة الإلكترونية https://goldenlicense.gov.eg ثم قدم المستندات المطلوبة، وسوف نقوم بمراجعتها.

2.      سنرسل كافة مستندات التعديل علي صفحتك الخاصة علي البوابة الإلكترونية.

·         *في حالة مواجهة أيه مشكلة أثناء أداء الخدمة إلكترونياً يرجى الاتصال بالخط الساخن علي 16035 من الساعة 8 صباحاً إلي الساعة 8 مساء بتوقيت القاهرة

 

  الأمانة الفنية لوحدة الرخصة الذهبية

 

·         الحضور للهيئة لتسلم المستندات المطلوبة.

 `,
      expanded: false,
    },
    {
      title: ' تحميل المستندات المساعدة ',
      content: ` `,
      expanded: false,
    },
  ];

  toggle(item: any) {
    item.expanded = !item.expanded;
  }
}
